export function isMobilePhone(raw) {
  const text = String(raw || '').trim().replace(/\s+/g, '');
  return /^1[3-9]\d{9}$/.test(text);
}

export function isWechatId(raw) {
  const text = String(raw || '').trim();
  return /^[a-zA-Z][-_a-zA-Z0-9]{5,19}$/.test(text) || /^\d+$/.test(text);
}

export function normalizeRegionName(input) {
  return String(input || '')
    .trim()
    .toLowerCase()
    .replace(/\s+/g, '')
    .replace(/(维吾尔自治区|壮族自治区|回族自治区|特别行政区|自治区|省|市|地区|盟)$/g, '');
}

export function isFuzzyMatch(source, target) {
  const a = normalizeRegionName(source);
  const b = normalizeRegionName(target);
  if (!a || !b) return false;
  return a.includes(b) || b.includes(a);
}

export function matchRegionCode(standardFields = {}, regionRows = []) {
  const provinceName = String(standardFields.areaProvince || '').trim();
  if (!provinceName || !Array.isArray(regionRows) || !regionRows.length) return '';

  const provinces = regionRows.filter(row => !(row.parent_code || row.parentCode));
  const province = provinces.find(row => isFuzzyMatch(provinceName, row.name));
  if (!province) return '';

  const areaName = String(standardFields.area || '').trim();
  if (!areaName) return province.code;

  const children = regionRows.filter(row => (row.parent_code || row.parentCode) === province.code);
  const child = children.find(row => isFuzzyMatch(areaName, row.name));
  return child ? child.code : province.code;
}

export function getRegionPathFromRows(code, regionRows = []) {
  if (!code || !Array.isArray(regionRows) || !regionRows.length) return [];
  const result = [];
  let current = regionRows.find(row => row.code === code);
  while (current) {
    result.unshift({ code: current.code, name: current.name });
    const parentCode = current.parent_code || current.parentCode;
    current = parentCode ? regionRows.find(row => row.code === parentCode) : null;
  }
  return result;
}
